export const HA_STATUS_KEY = 'hiring_authority_status_id';
export const SUB_STATUS_KEY = 'sub_status_id';

export const CHAINED_SELECTS = {
  specialty_id: ['subspecialty_id', 'position_id'],
  [HA_STATUS_KEY]: [SUB_STATUS_KEY]
};

export const FIELD_KEYS = [
  'first_name',
  'last_name',
  'specialty',
  'subspecialty',
  'position',
  'specialty_id',
  'subspecialty_id',
  'position_id',
  'title',
  'work_email',
  'work_phone',
  'ext',
  'personal_email',
  'personal_phone',
  'other_ext',
  HA_STATUS_KEY,
  SUB_STATUS_KEY,
  'keywordTags'
];

export const PHONE_PROPS = { 'aria-label': 'phone' };
